import $ from 'jquery';
import URI from 'urijs';
import 'urijs/URI.fragmentQuery';
import 'slick-carousel';

type Dictionary = { [ key: string ]: string; };

function getHashMapValues(hashValue) {
  const hashDictionary:Dictionary = {};
  hashValue.split('&').forEach(item => {
    hashDictionary[item.split('=')[0]] = decodeURIComponent(item.split('=')[1]);
  });
  //console.log("1" +hashDictionary.toString());
  return hashDictionary;
}

function loadlightboxPopup () {
  var hash:Dictionary = getHashMapValues(URI().fragmentPrefix('').fragment());
    if (hash.lightbox) {
      var videoID = hash.lightbox;
      getDialogContent(videoID);
    } else if(hash.standardssearch) {
        var standardId = hash.standardssearch;
        getDialogContent(standardId, '/system/standardssearch');
    }
}

function initCarousel() {
  $('.lb-carouselgroup').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3
  });

  $('.lb-carouselgroup').slick('setPosition'); 
  $('a.switchlightbox').on('click', function (e) {
    e.preventDefault(); 
    var videoIframe = $('.youtube-video');
    var videoID = $(this).attr('href').split('#')[1];
    videoIframe.attr('src', 'https://www.youtube.com/embed/' + videoID + '?autoplay=True&loop=0&rel=0&search=0&wmode=opaque&enablejsapi=1');
    var content = $(this).nextAll('.video-content');
    $('.dv-content').empty().append(content.children().clone());
  });
}

// Asyncronously load dialog content
function getDialogContent(dialogId, lightboxUrl = "/system/lightbox") {
    var param = "?id=" + dialogId;
    var dataUrl = lightboxUrl + param;
     var dialog = $('.dialog');

    if ($('#scWebEditRibbon').length > 0 ) { 
      $('#ribbonPreLoadingIndicator').remove();
    }
  
    $(".dialog-asset")
        .html("")
        .load(dataUrl,
            function (r, s, x) {
          
                if (s === "error") {
                    var err = "Error: " + x.status + " " + x.statusText;
                    // console.log(err);

                    $(".dialog-asset")
                        .html("<div class=\"error\"><p>Sorry! There was a problem loading the resource: " +
                            dataUrl +
                            "</p></div>");
                }
                if (s == "success") {
                     initCarousel();
                }
               
                
            });

     var contentWidth = $("#" + dialogId).find('.dialog-content').width();
      var target = $("#" + dialogId).find('.dialog-content').html();
      var bodyHeight = $('html').height() + 70;

      dialog.attr('id', dialogId).attr('aria-labeledby', dialogId);
      dialog.attr('aria-hidden', 'false').removeClass('hidden');
      dialog.find(".dialog-asset").on('focus', null);
      $('a, input, button').attr('tabindex', '-1');
      $('button.close').attr('tabindex', '0');
      $('html').addClass('noscroll');

}

$(function() {
  //Open popup
 
    //Close dialogs
    $('button.close').on('click', function () {
      var dialog = $(this).parent().parent('.dialog');
      dialog.find('.dialog-asset').empty();
      dialog.attr('aria-hidden', 'true').addClass('hidden');
      $('a, input, button').attr('tabindex', '0');
      $('html').removeClass('noscroll');
      //location.hash = URI().fragmentPrefix('').removeFragment('lightbox').removeFragment('standardssearch').fragment();
      if (history.replaceState) {
        history.replaceState('', document.title, location.pathname + location.search);
      } else {
        location.hash = '';
      }
    });

  //if they are focused inside the dialog you can escape
  $(".dialog").on('keydown', function(ev: JQuery.Event) {
        if (ev.which == 27) {
            $(".close").on('click', ()=>{});
        }
  });
  loadlightboxPopup();
  $(window).on( 'hashchange', function(){
      var fragement:Dictionary = getHashMapValues(URI().fragmentPrefix('').fragment());
      if(fragement.lightbox || fragement.standardssearch) {
        loadlightboxPopup();
      }
  });
});
